export const formatDollarInputValue = (value: string, showDecimal: boolean = true): string => {
  const newValue = value.replace(/[^0-9]/g, '');
  const amount = parseFloat(newValue) ?? 0;
  const amountString = showDecimal ? (amount / 100).toFixed(2) : amount.toString()
  return amount ? amountString.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
}

export const formatPhoneInputValue = (value: string): string => {
    // Remove all non spaces, numbers, parenthesis, dashes and plus signs
    return  value.replace(/[^0-9-+() ]/g, '');
}

export const preparePhoneForAWS = (value: string): string => {
    // remove all non numbers and plus signs
    return value.replace(/[^0-9+]/g, '');
}

export const formatPostalCodeInputValue = (value: string): string => {
    return value.replace(/[^0-9a-zA-Z- ]/g, '');
}

export const formatTaxIdInputValue = (value: string): string => {
    // Only allow 9 number characters
    return value.replace(/[^0-9]/g, '').slice(0, 9);
}

export const formatCharacterLimitInputValue = (value: string, limit: number): string => {
    return value.slice(0, limit);
}

export const formatEmailInputValue = (value: string): string => {
    return value.replace(/[^0-9a-zA-Z@.]/g, '');
}

export const formatURLInputValue = (value: string): string => {
    return value.replace(/[^0-9a-zA-Z;,/?:@&=+$\-_.!~*'()#]/g, '');
}

export const formatMaskedInputValue = (value: string, oldValue: string, maskStart: string = "XX"): string => {
    if (oldValue.startsWith(maskStart)) {
        if (value.length > oldValue.length) {
            // Return the last character of the value
            return value.slice(-1).trim();
        } 
            // Return an empty string so the value can start over unmasked
            return ""
        
    }
    return value;
}